/**
 * Rechtekatalog — Spiegelung von public.permissions.
 *
 * Die Datenbank bleibt die Wahrheit. Diese Union existiert nur, damit ein
 * Tippfehler in `useCan('documnet:read')` beim Compilieren auffliegt statt
 * still `false` zu liefern und eine Schaltflaeche unsichtbar zu machen.
 *
 * Neues Recht? Erst die Migration, dann diese Liste.
 */

export const PERMISSIONS = [
  'space:read',
  'space:create',
  'space:update',
  'space:archive',
  'space:manage_members',

  'document:read',
  'document:create',
  'document:update',
  'document:delete',
  'document:publish',

  'project:read',
  'project:create',
  'project:update',
  'project:archive',

  'part:read',
  'part:create',
  'part:update',

  'change:read',
  'change:create',
  'change:review',
  'change:approve',

  'equipment:read',
  'equipment:manage',

  /*
    Das einzige Recht, das eine SIMULATORKACHEL sperrt.

    Alle anderen Kacheln rechnen und stehen jedem Angemeldeten offen — eine
    Momentenkurve ist keine Verschlusssache. Die Umsetzung ist etwas anderes:
    dort stehen Termine, Verantwortlichkeiten, Personalaufbau und Kosten, also
    Angaben über Menschen und über das Vorhaben.
  */
  'roadmap:read',

  'user:read',
  'user:invite',
  'user:suspend',
  'role:assign',
  'audit:read',
  'settings:manage',
] as const

export type Permission = (typeof PERMISSIONS)[number]

/** Globale Rollen — genau eine pro Person. */
export type GlobalRole = 'owner' | 'admin' | 'member' | 'guest'

/** Rollen innerhalb eines Bereichs. */
export type SpaceRole =
  | 'space_lead'
  | 'space_editor'
  | 'space_contributor'
  | 'space_viewer'

export const GLOBAL_ROLE_LABELS: Record<GlobalRole, string> = {
  owner: 'Owner',
  admin: 'Administrator',
  member: 'Mitarbeiter',
  guest: 'Gast',
}

export const SPACE_ROLE_LABELS: Record<SpaceRole, string> = {
  space_lead: 'Bereichsleitung',
  space_editor: 'Redakteur',
  space_contributor: 'Mitwirkender',
  space_viewer: 'Leser',
}

/** Ein Bereich aus Sicht des angemeldeten Nutzers. */
export interface SpaceMembership {
  id: string
  slug: string
  name: string
  kind: 'bereich' | 'projekt'
  role: SpaceRole
  permissions: Permission[]
}

export interface Profile {
  id: string
  email: string
  full_name: string | null
  avatar_url: string | null
  department: string | null
  job_title: string | null
  status: 'active' | 'suspended'
  created_at: string
  updated_at: string
}

/** Rueckgabe von public.my_context(). */
export interface AuthContextData {
  profile: Profile | null
  global_role: GlobalRole | null
  permissions: Permission[]
  spaces: SpaceMembership[]
}
